import React, { Component } from 'react';
import { NavLink, Container, Col, Row, Table, Form, FormGroup, FormText, Label } from 'reactstrap';

import { Currency } from '../Controls/Currency';
import { CalculationInfo } from './CalculationInfo';

import { ComboBox } from '@fluentui/react';
import { Estimate } from './Estimate';
const smsOptions = [];
const revenueOptions = [];
const industryOptions = [];

const labelStyles = {
    fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
    fontSize: '14px',
    fontWeight: 600,
    color: "rgb(50,49,48)",
    boxSizing: "border-box",
    boxShadow: "none",
    margin: "0px",
    display: "inline-block",
    padding: "0px 7px 0px 0px",
    overflowWrap: "break-word"
}


export class QuoteView extends Component {
    static displayName = QuoteView.name;

    constructor(props) {
        super(props)

        this.onItemClick = this.onItemClick.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }
    componentDidMount() {

    }
    onItemClick(item) {
        if (this.props.onOpen) {
            this.props.onOpen(item);
        }
    }
    renderForm(quote) {
        return (
            <div style={{ padding: "20px 20px", minWidth: "1360px" }}>
                <img className="d-none d-print-block" src="/Images/horizlogo.png" alt="Networking Technologies horizontal logo" />
                <br className="d-none d-print-block " />
                <Container fluid={true}>
                    <Row>
                        <Col md={6}>
                            <Row>
                                <h5>Company Information</h5>
                            </Row>
                            <Row>
                                <label style={labelStyles}>Company:</label> {quote.companyName}
                            </Row>
                            <Row>
                                <label style={labelStyles}>Territory:</label> {quote.territoryName}
                            </Row>
                            <Row>
                                <label style={labelStyles}>Product:</label> {quote.smsTypeText}
                            </Row>
                            <Row>
                                <label style={labelStyles}>Revenue Range:</label> {quote.revenueText}
                            </Row>
                            <Row>
                                <label style={labelStyles}>Vertical:</label> {quote.industryText}
                            </Row>
                            <Row>
                                <h5 style={{ marginTop: "20px" }}>Contact Information</h5>
                            </Row>
                            <Row >
                                <Col md={6}>
                                    <label style={labelStyles}>First Name:</label> {quote.firstName}
                                </Col>
                                <Col md={6}>
                                    <label style={labelStyles}>Last Name:</label> {quote.lastName}
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={6}>
                                    <label style={labelStyles}>Phone:</label> {quote.phoneNumber}
                                </Col>
                                <Col md={6}>
                                    <label style={labelStyles}>E-Mail:</label> {quote.email}
                                </Col>
                            </Row>
                            <Row style={{ marginTop: "20px" }}><h5>Item Counts</h5></Row>

                            <Row form>
                                <Col md={3}>
                                    <label style={labelStyles}>NTSA:</label>
                                </Col>
                                <Col md={1}>
                                    {quote.ntsa}
                                </Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Users:</label>
                                </Col>
                                <Col md={1}>{quote.users}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Workstations:</label>
                                </Col>
                                <Col md={1}>{quote.workstations}</Col>

                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <label style={labelStyles}>Servers:</label>
                                </Col>
                                <Col md={1}>{quote.servers}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>ESX/VM Hosts:</label>
                                </Col>
                                <Col md={1}>{quote.esxHosts}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>SAN:</label>
                                </Col>
                                <Col md={1}>{quote.san}</Col>

                            </Row>

                            <Row form>
                                <Col md={3}>
                                    <label style={labelStyles}>Firewalls:</label>
                                </Col>
                                <Col md={1}>{quote.firewalls}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Switches / Routers:</label>
                                </Col>
                                <Col md={1}>{quote.switchesRouters}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Phys Wireless Ctrlrs:</label>
                                </Col>
                                <Col md={1}>{quote.wirelessControllers}</Col>
                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <label style={labelStyles}>Virt Wireless Ctrlrs:</label>
                                </Col>
                                <Col md={1}>{quote.virtualWirelessControllers}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Access Points:</label>
                                </Col>
                                <Col md={1}>{quote.accessPoint}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>IP Cameras:</label>
                                </Col>
                                <Col md={1}>{quote.ipCamera}</Col>

                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <label style={labelStyles}>IP Phones:</label>
                                </Col>
                                <Col md={1}>{quote.ipPhone}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>UPSs:</label>
                                </Col>
                                <Col md={1}>{quote.ups}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Backup Appliances:</label>
                                </Col>
                                <Col md={1}>{quote.backupAppliance}</Col>

                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <label style={labelStyles}>Printers:</label>
                                </Col>
                                <Col md={1}>{quote.printers}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Other SNMP Devices:</label>
                                </Col>
                                <Col md={1}>{quote.otherSnmpDevices}</Col>
                                <Col md={3}>
                                    <label style={labelStyles}>Other ICMP Devices:</label>
                                </Col>
                                <Col md={1}>{quote.otherIcmpDevices}</Col>

                            </Row>
                            <Row form>
                                <Col md={3}><label style={labelStyles}>Locations:</label></Col>
                                <Col md={1}>{quote.locations}</Col>
                                <Col md={3}><label style={labelStyles}>Domains:</label></Col>
                                <Col md={1}>{quote.domains}</Col>
                            </Row>

                        </Col>
                        <Col>
                            <h4>Estimate Results</h4>

                            <h5>Initial Fees</h5>
                            <Table striped size="sm">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>Qty</th>
                                        <th>Unit $</th>
                                        <th className="resultExtWidth">Ext $</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Onboarding</td>
                                        <td>1</td>
                                        <td>
                                            <Currency value={quote.onboardingUnitPriceOverride < 0 ? quote.onboardingUnitPrice : quote.onboardingUnitPriceOverride} />
                                        </td>
                                        <td><Currency value={quote.onboardingExtPrice} /></td>
                                    </tr>

                                    <tr>
                                        <td>Initial Assessment</td>
                                        <td>1</td>
                                        <td><Currency value={quote.initialAssessmentUnitPrice} /></td>
                                        <td><Currency value={quote.initialAssessmentExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>Initial Policy Mgmt.</td>
                                        <td>1</td>
                                        <td><Currency value={quote.initialPolicyManagementUnitPrice} /></td>
                                        <td><Currency value={quote.initialPolicyManagementExtPrice} /></td>
                                    </tr>


                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th><Currency value={quote.totalInitialFees} /> NRC</th>
                                    </tr>
                                </tfoot>
                            </Table>

                            <h5>Annual Cyber Insurance Fee</h5>
                            <Table striped size="sm">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th className="resultExtWidth">Ext $</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Cyber Policy</td>
                                        <td><Currency value={quote.cyberInsuranceFee} /></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th><Currency value={quote.cyberInsuranceFee} /> Annual</th>
                                    </tr>
                                </tfoot>
                            </Table>
                            <h5>SMS Monthly Fees</h5>
                            <Table striped size="sm">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>Qty</th>
                                        <th>Unit $</th>
                                        <th className="resultExtWidth">Ext $</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Endpoints</td>
                                        <td>{quote.endPointQty}</td>
                                        <td><Currency value={quote.endpointUnitPrice} /></td>
                                        <td><Currency value={quote.endpointExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>Devices</td>
                                        <td>{quote.deviceQty}</td>
                                        <td><Currency value={quote.deviceUnitPrice} /></td>
                                        <td><Currency value={quote.deviceExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>Users</td>
                                        <td>{quote.userQty}</td>

                                        <td><Currency value={quote.userUnitPrice} /></td>
                                        <td><Currency value={quote.userExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>NTSA Locations</td>
                                        <td>{quote.locationQty}</td>
                                        <td><Currency value={quote.locationUnitPrice} /></td>
                                        <td><Currency value={quote.locationExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>Mon. Devices</td>
                                        <td>{quote.mDeviceQty}</td>
                                        <td><Currency value={quote.mDeviceUnitPrice} /></td>
                                        <td><Currency value={quote.mDeviceExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>Companies</td>
                                        <td>1</td>
                                        <td><Currency value={quote.companyUnitPrice} /></td>
                                        <td><Currency value={quote.companyExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>SOC Devices</td>
                                        <td>{quote.socDeviceQty}</td>
                                        <td><Currency value={quote.socDeviceUnitPrice} /></td>
                                        <td><Currency value={quote.socDeviceExtPrice} /></td>
                                    </tr>
                                    <tr>
                                        <td>Domains</td>
                                        <td>{quote.domainsQty}</td>
                                        <td><Currency value={quote.domainsUnitPrice} /></td>
                                        <td><Currency value={quote.domainsExtPrice} /></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th><Currency value={quote.totalSmsMonthlyFees} /> MRC</th>
                                    </tr>
                                </tfoot>
                            </Table>
                            <h5>Block Time Estimate</h5>
                            <Table striped size="sm">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>Qty</th>
                                        <th>Unit $</th>
                                        <th className="resultExtWidth">Ext $</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Monthly BTU</td>
                                        <td>
                                            {quote.blockTimeQuantityOverride < 0 ? quote.blockTimeQuantity : quote.blockTimeQuantityOverride}

                                        </td>
                                        <td><Currency value={quote.blockTimeUnitPrice} /></td>
                                        <td><Currency value={quote.blockTimeExtPrice} /></td>
                                    </tr>

                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th><Currency value={quote.blockTimeExtPrice} /> MRC</th>
                                    </tr>
                                </tfoot>
                            </Table>
                        </Col>
                    </Row>
                </Container>
                <CalculationInfo items={quote.calculationInfo}></CalculationInfo>
                <footer>Based on :{quote.formulaVersion} </footer>
            </div>
        )
    }
    render() {
        var quote = this.props.quote;
        if (quote) {
            return this.renderForm(quote);

        } else {
            return (<div>A quote is not currently loaded. This is an error. Please contact Andy.</div>)
        }
    }
}